import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentVariableValue on VariableValue {
    variable
    value
  }
`
// TODO use record transformer
export const LOOKUP_TRANSFORMER = graphql.transformers.OUT.nullable(
  graphql.transformers.OUT.custom<
    readonly (graphql.schema.FragmentVariableValueFragment | Nullish)[],
    ents.core.dms.data.query.Variable.Lookup
  >(variables => {
    const variablesLookup: ents.core.dms.data.query.Variable.Lookup = {}
    for (const variableValue of variables) {
      const variable = variableValue?.variable
      const value = variableValue?.value
      if (variable && value) {
        // value is of graphql type AWSJSON so we know it is a string
        variablesLookup[variable] = JSON.parse(value as string)
      }
    }
    return variablesLookup
  }),
)
